import { render, staticRenderFns } from "./FormGrades.vue?vue&type=template&id=03590288&scoped=true"
import script from "./FormGrades.vue?vue&type=script&lang=js"
export * from "./FormGrades.vue?vue&type=script&lang=js"
import style0 from "./FormGrades.vue?vue&type=style&index=0&id=03590288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03590288",
  null
  
)

export default component.exports